import React from "react";

import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Checkbox from "shared/components/CheckBox";
import { NAME_SPACES } from "shared/locals/constants";

import "./styles.scss";

const ListCheckProduct = ({ data, onClick, checkedItem, setCheckedItem }) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS, {
    keyPrefix: "LIST_PRODUCT_CHECK",
  });
  return (
    <div
      className={`product--check--card ${
        isEqual(checkedItem, data) ? "active--product--check--card" : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        setCheckedItem(data);
        onClick(data);
      }}>
      <Checkbox checked={isEqual(checkedItem, data)} />
      <div className={"product--check--card--wrap"}>
        <div className={"product--check--card--wrap--left"}>
          <img src={data.productPhoto} alt={"Product"} />
        </div>
        <div className={"product--check--card--wrap--right"}>
          <h3 className={"text--16"}>
            {t("PRODUCT_REF", {
              productRef: data?.productRef,
            })}
          </h3>
          <h3 className={"text--14"}>
            {data.productDesc} - {data.productBrand}
          </h3>
          <h3 className={"text--14"}>{data.sn}</h3>
        </div>
      </div>
    </div>
  );
};

ListCheckProduct.propTypes = {
  data: PropTypes.shape({
    productBrand: PropTypes.string,
    productCode: PropTypes.string,
    productDesc: PropTypes.string,
    productPhoto: PropTypes.string,
    productRef: PropTypes.string,
    sn: PropTypes.string,
  }),
  checkedItem: PropTypes.shape({
    productBrand: PropTypes.string,
    productCode: PropTypes.string,
    productDesc: PropTypes.string,
    productPhoto: PropTypes.string,
    productRef: PropTypes.string,
    sn: PropTypes.string,
  }),
  onClick: PropTypes.func,
  setCheckedItem: PropTypes.func,
};

ListCheckProduct.defaultProps = {};

export default ListCheckProduct;
